module.exports = __webpack_public_path__ + "static/media/branch-detail-960.d92c10c0.webp";